import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const StyledActionContainer = styled(Flex)<FlexProps>``;

export const StyledEditableTileContainer = styled(Flex)<
	FlexProps & {
		$hasEditPermission?: boolean;
		$withBorder?: boolean;
		$backgroundColor?: string;
	}
>`
	border-radius: 0.25rem;
	${({ $withBorder, theme }) =>
		$withBorder ? `border: 1px solid ${theme.v3.colors.gray[4]};` : ''}
	${({ $backgroundColor }) => ($backgroundColor ? `background-color: ${$backgroundColor};` : '')}
	${StyledActionContainer} {
		opacity: 0;
	}

	&:hover {
		background-color: ${({ $hasEditPermission, $backgroundColor, theme }) =>
			$hasEditPermission ? theme.v3.colors.gray[0] : $backgroundColor ?? 'transparent'};

		${StyledActionContainer} {
			opacity: 1;
		}
	}
`;
